<div class="modal-bg" (click)="closeModal()"></div>
<div class="modal-content" [ngStyle]="contentStyle">
  <div class="modal-loading-container" *ngIf="this.loading">
    <span><i class="fa fa-spinner fa-pulse fa-fw fa-5x"></i></span>
  </div>
  <ng-container *ngIf="!this.loading">
    <ng-content [ngStyle]="{ width: '100%' }"></ng-content>
  </ng-container>
</div>
